import { render, staticRenderFns } from "./BrickAndSubstructure.vue?vue&type=template&id=6e1e0359&scoped=true"
import script from "./BrickAndSubstructure.vue?vue&type=script&lang=js"
export * from "./BrickAndSubstructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1e0359",
  null
  
)

export default component.exports